import { mount } from './utils';

class ComponentPopper {
  constructor(elementId = 'component-popper-wrapper') {
    this.el = document.getElementById(elementId);
    this.$$components = [];
  }

  show(component, props, options = {}) {
    const index = this.$$components.length;
    const restoreFocusTo = options.restoreFocusTo || document.activeElement;
    const { promise, requestClose } = mount(this.getElement(), component, props, {
      ...options,
      restoreFocusTo,
      shouldRestoreFocus: () => this.canRestoreFocus(index),
      onClosed: () => this.finishClose(index)
    });
    this.$$components.push({ promise, index, requestClose, restoreFocusTo, closing: false });

    return { promise, index };
  }

  getElement() {
    const el = document.createElement('div');
    this.el.appendChild(el);
    return el;
  }

  close(index) {
    const comp = this.$$components[index];
    if (!comp || comp.closing) {
      return;
    }
    comp.closing = true;
    comp.requestClose();
  }

  canRestoreFocus(index) {
    const topComponent = this.$$components.slice().reverse().find(Boolean);
    return topComponent?.index === index;
  }

  finishClose(index) {
    this.$$components[index] = null;

    if (!this.$$components.some(Boolean)) {
      this.$$components = [];
    }
  }
}

export default new ComponentPopper();
